import { receivableInvoicesApiNamespace } from 'receivable-invoices-js/constants/hosts';
import { qontoClient } from 'receivable-invoices-js/react/utils/api-clients/qonto';
import { camelizeKeys } from 'receivable-invoices-js/react/utils/camelize-keys';
import { fetchCreditNote } from './fetch-credit-note';

vi.mock('receivable-invoices-js/react/utils/api-clients/qonto');
vi.mock('receivable-invoices-js/constants/hosts', () => ({
  receivableInvoicesApiNamespace: '/api/v5',
}));

vi.mock('@repo/design-system-kit', () => ({
  useToast: vi.fn(() => ({
    showToast: vi.fn(),
  })),
}));

describe('unit | API | queries | fetch-credit-note', () => {
  const mockQontoClient = vi.mocked(qontoClient);
  const creditNoteId = 'credit-note-123';
  const URL = `${receivableInvoicesApiNamespace}/receivable_invoices/credit_notes/shared`;

  beforeEach(() => {
    vi.clearAllMocks();
  });

  describe(fetchCreditNote, () => {
    it('fetches credit note successfully', async () => {
      const apiResponse = {
        data: {
          id: creditNoteId,
          type: 'receivable_credit_notes',
          attributes: {
            id: creditNoteId,
            number: 'CN-001',
            amount_due: {
              value: '50.00',
              currency: 'EUR',
            },
            currency: 'EUR',
            locale: 'en',
            pdf_url: 'https://example.com/credit-note.pdf',
            status: 'issued',
            organization: {
              id: 'org-123',
              legal_name: 'Test Organization',
            },
            customer_snapshot: {
              kind: 'company',
              name: 'Test Company',
              id: 'customer-123',
            },
            original_invoice: {
              number: 'INV-001',
            },
            sections: [],
            items: [],
            einvoicing_status: 'not_sent',
            terms_and_conditions: 'Terms text',
            subtotal: {
              value: '45.00',
              currency: 'EUR',
            },
            vat_amount: {
              value: '5.00',
              currency: 'EUR',
            },
            reason: 'Customer requested refund',
            issue_date: '2025-01-15',
            is_pdf_generated: true,
            logo_url: 'https://example.com/logo.png',
            contact_email: 'test@example.com',
            header: 'Header text',
            footer: 'Footer text',
            welfare_fund_amount: {
              value: '0.00',
              currency: 'EUR',
            },
            withholding_tax_amount: {
              value: '0.00',
              currency: 'EUR',
            },
            stamp_duty_amount: {
              value: '0.00',
              currency: 'EUR',
            },
          },
        },
      };

      mockQontoClient.mockResolvedValue(apiResponse);

      const result = await fetchCreditNote({ id: creditNoteId }, {});

      expect(mockQontoClient).toHaveBeenCalledWith(`${URL}/${creditNoteId}`);

      const expected = camelizeKeys({
        ...apiResponse.data.attributes,
        id: creditNoteId,
      });

      expect(result).toStrictEqual(expected);
    });

    it('handles API errors with custom error handler', async () => {
      const error = new Error('API Error');
      mockQontoClient.mockRejectedValue(error);

      const onError = vi.fn<(err: unknown) => void>();
      await fetchCreditNote({ id: creditNoteId }, { onError });

      expect(onError).toHaveBeenCalledWith(error);
    });

    it('throws error when no error handler is provided', async () => {
      const error = new Error('API Error');
      mockQontoClient.mockRejectedValue(error);

      await expect(fetchCreditNote({ id: creditNoteId }, {})).rejects.toThrow('API Error');
    });
  });
});
